import {safeDecodeURI,} from '@/assets/js/src/util/safeDecodeURI'

export function safeEncodeURI (str, keepSlashes = false) {
    return keepSlashes ? encodeURI(safeDecodeURI(str)) : encodeURIComponent(safeDecodeURI(str))
}